import styled from 'styled-components';

export const Page = styled('div')({
  padding:' 4em',
  position: 'relative',
  height: '100%',
  width: '100%',
});
